/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.25 21C5.48333 21 4.83333 20.7333 4.3 20.2C3.76667 19.6667 3.5 19.0167 3.5 18.25V4.75C3.5 3.98333 3.76667 3.33333 4.3 2.8C4.83333 2.26667 5.48333 2 6.25 2H19.75C20.5167 2 21.1667 2.26667 21.7 2.8C22.2333 3.33333 22.5 3.98333 22.5 4.75V18.25C22.5 19.0167 22.2333 19.6667 21.7 20.2C21.1667 20.7333 20.5167 21 19.75 21H6.25ZM6.25 19.5H19.75C20.1 19.5 20.396 19.379 20.638 19.137C20.8793 18.8957 21 18.6 21 18.25V4.75C21 4.4 20.8793 4.104 20.638 3.862C20.396 3.62067 20.1 3.5 19.75 3.5H6.25C5.9 3.5 5.60433 3.62067 5.363 3.862C5.121 4.104 5 4.4 5 4.75V18.25C5 18.6 5.121 18.8957 5.363 19.137C5.60433 19.379 5.9 19.5 6.25 19.5ZM7.6 17L11 13.6L12.825 15.4L15 12.65L18.475 17H7.6ZM9.25 9.25C8.76667 9.25 8.35433 9.07933 8.013 8.738C7.671 8.396 7.5 7.98333 7.5 7.5C7.5 7.01667 7.671 6.604 8.013 6.262C8.35433 5.92067 8.76667 5.75 9.25 5.75C9.73333 5.75 10.146 5.92067 10.488 6.262C10.8293 6.604 11 7.01667 11 7.5C11 7.98333 10.8293 8.396 10.488 8.738C10.146 9.07933 9.73333 9.25 9.25 9.25Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
